import { combineReducers } from 'redux';
import { createResponsiveStateReducer } from 'redux-responsive';
import { reducer as formReducer } from 'redux-form';

import auth from './common/auth/reducers';
import badges from './badges/reducers';
import courses from './courses/reducers';
import followUps from './follow-ups/redux/reducers';
import golfSchools from './golf-schools/reducers';
import ms from './movement-specialists/reducers';
import settings from './settings/reducers';
import swingSubmittals from './swing-submittals/reducers';
import tv from './tv/reducers';
import users from './users/reducers';
import library from './library/reducers';

export default combineReducers({
  auth,
  badges,
  browser: createResponsiveStateReducer(),
  courses,
  followUps,
  form: formReducer,
  ms,
  golfSchools,
  settings,
  swingSubmittals,
  tv,
  users,
  library,
});



// WEBPACK FOOTER //
// ./src/reducers.js